import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haTemplateshareDoctor'
})
export class HaTemplateshareDoctorPipe implements PipeTransform {

  transform(doctorData: any[], searchTermDoctorr: string): any[]{
    if (!doctorData || !searchTermDoctorr) { return doctorData; }
    return doctorData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermDoctorr.toLowerCase().trim()) !== -1
     




    );
  }

}
